// Wraps a single <dialog id="bundle-name-dialog"> (rendered from
// snippets/bundle-name-dialog.liquid) as a reusable name-prompt. Mirrors the
// open/close animation pattern used by the Dialog class in modules/dialog.ts.
export class NameDialog {
  private input: HTMLInputElement;
  private confirmBtn: HTMLButtonElement;
  private cancelBtn: HTMLButtonElement;
  private resolveFn: ((value: string | null) => void) | null = null;

  constructor(private dialogEl: HTMLDialogElement) {
    this.input = dialogEl.querySelector('.bundle-name-dialog__input') as HTMLInputElement;
    this.confirmBtn = dialogEl.querySelector('.bundle-name-dialog__confirm') as HTMLButtonElement;
    this.cancelBtn = dialogEl.querySelector('.bundle-name-dialog__cancel') as HTMLButtonElement;

    this.input.addEventListener('input', () => {
      this.confirmBtn.disabled = this.input.value.trim().length === 0;
    });

    this.confirmBtn.addEventListener('click', () => this.settle(this.input.value.trim()));
    this.cancelBtn.addEventListener('click', () => this.settle(null));

    this.dialogEl.addEventListener('click', (e) => {
      if (e.target === this.dialogEl) this.settle(null);
    });

    this.dialogEl.addEventListener('cancel', (e) => {
      e.preventDefault();
      this.settle(null);
    });
  }

  prompt(defaultValue: string): Promise<string | null> {
    // Resolve any still-pending prompt before starting a new one, so a second
    // call can never leak the first call's promise.
    this.resolveFn?.(null);

    this.input.value = defaultValue;
    this.confirmBtn.disabled = defaultValue.trim().length === 0;
    this.dialogEl.classList.remove('is-closing');
    this.dialogEl.showModal();
    document.body.classList.add('--no-scroll');
    this.input.focus();
    this.input.select();

    return new Promise((resolve) => {
      this.resolveFn = resolve;
    });
  }

  private settle(value: string | null) {
    const resolve = this.resolveFn;
    this.resolveFn = null;
    this.dialogEl.classList.add('is-closing');
    setTimeout(() => {
      this.dialogEl.close();
      document.body.classList.remove('--no-scroll');
    }, 300);
    resolve?.(value);
  }
}
